import React from 'react'
import { useRewards } from '@/hooks/useRewards'
import { REWARD_TYPES } from '@/utils/constants/rewardsConstants'
import { Divider } from '@/components/atoms'
import styles from '../RewardSetup/RewardSetup.module.scss'
import { 
  AvailabilitySection, 
  AdditionalAttributesSection 
} from './ui-components'
import RewardPreview from '@/containers/Rewards/RewardSetup/ui-components/RewardPreview'

/**
 * RewardAttributes component - Step 3 of the reward creation process.
 * Contains preview message, availability dates, and additional attributes.
 * 
 * @returns {JSX.Element} The rendered RewardAttributes component.
 */
const RewardAttributes = () => {
  const {
    formData,
    validation,
    handleFormChange,
    handleValidation,
  } = useRewards()

  return (
    <div className="flex flex-col gap-6">
      {/* Combined Attributes Card */}
      <div className={`rounded-lg p-6 flex flex-col gap-6 ${styles.rewardSetup__card}`}>
        {/* Preview Message - Show for all reward types */}
        {Object.values(REWARD_TYPES).includes(formData.rewardType) && (
          <>
            <RewardPreview 
              formData={formData} 
              contentClassName="text-left text-base font-bold text-white"
              renderOnlyText={true}
            />
            <Divider className="mb-0 mt-0" />
          </>
        )}

        {/* Availability Section */}
        <AvailabilitySection
          formData={formData}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
        />

        {/* Divider */}
        <Divider className="mb-0 mt-0" />

        {/* Additional Attributes Section */}
        <AdditionalAttributesSection
          formData={formData}
          validation={validation}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
        />
      </div>
    </div>
  )
}

export default RewardAttributes 